var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 27.2667V10.8667C3.68897 10.8222 3.38897 10.6 3.10008 10.2C2.81119 9.80002 2.66675 9.36669 2.66675 8.90002V4.66669C2.66675 4.15558 2.86675 3.69446 3.26675 3.28335C3.66675 2.87224 4.13341 2.66669 4.66675 2.66669H27.3334C27.8445 2.66669 28.3056 2.87224 28.7167 3.28335C29.1279 3.69446 29.3334 4.15558 29.3334 4.66669V8.90002C29.3334 9.36669 29.189 9.80002 28.9001 10.2C28.6112 10.6 28.3112 10.8222 28.0001 10.8667V27.2667C28.0001 27.7778 27.7945 28.25 27.3834 28.6834C26.9723 29.1167 26.5112 29.3334 26.0001 29.3334H6.00008C5.46675 29.3334 5.00008 29.1167 4.60008 28.6834C4.20008 28.25 4.00008 27.7778 4.00008 27.2667ZM27.3334 8.90002V4.66669H4.66675V8.90002H27.3334ZM12.0001 17.9H20.0001V15.9H12.0001V17.9Z",
    fill: "#AD9078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.40fb86beb3cda43ac6612a807f809bcd.svg";
export { ForwardRef as ReactComponent };